namespace RioERP.Orders {
    export namespace WebsiteOrderProductsService {
        export const baseUrl = 'Orders/WebsiteOrderProducts';

        export declare function Create(request: Serenity.SaveRequest<WebsiteOrderProductsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WebsiteOrderProductsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WebsiteOrderProductsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WebsiteOrderProductsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/WebsiteOrderProducts/Create",
            Update = "Orders/WebsiteOrderProducts/Update",
            Delete = "Orders/WebsiteOrderProducts/Delete",
            Retrieve = "Orders/WebsiteOrderProducts/Retrieve",
            List = "Orders/WebsiteOrderProducts/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>WebsiteOrderProductsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
